import React, { useState } from "react";
import styles from "./floating-input.module.css"; // Ensure this path matches your file structure

const FloatingLabelInput = ({ label, value, setValue, isDisabled = false }) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(value !== "");
  const handleChange = (e) => setValue(e.target.value);

  return (
    <div className={styles.inputWrapper}>
      <label
        className={`${styles.floatingLabel} ${
        isFocused || value ? styles.focused : ""}`
        }>

        {label}
      </label>
      <input
        className={styles["text-input"]}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
        value={value}
        disabled={isDisabled} />

    </div>);

};

export default FloatingLabelInput;